"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgChannelVoicer = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgChannelVoicer = function SvgChannelVoicer(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fill: "url(#sc_voicer__paint0_linear)",
    d: "M0 0h120v120H0z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M87.344 57.5a2.344 2.344 0 00-4.688 0c0 12.493-10.163 22.656-22.656 22.656-12.493 0-22.656-10.163-22.656-22.656a2.344 2.344 0 00-4.688 0c0 14.288 11.016 26.05 25 27.242v10.57H45A2.344 2.344 0 0045 100h30a2.344 2.344 0 000-4.688H62.344v-10.57c13.984-1.193 25-12.954 25-27.242z",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M68.75 59.844a2.344 2.344 0 010-4.688h8.594v-5.312H66.25a2.344 2.344 0 010-4.688h11.094v-5.312H68.75a2.344 2.344 0 010-4.688h8.534C76.574 26.68 69.514 20 60.937 20h-1.874c-8.578 0-15.638 6.68-16.347 15.156h8.534a2.344 2.344 0 010 4.688h-8.594v5.312H53.75a2.344 2.344 0 010 4.688H42.656v5.312h8.594a2.344 2.344 0 010 4.688h-8.533c.716 8.39 7.773 15 16.346 15h1.874c8.573 0 15.63-6.61 16.346-15H68.75z",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "sc_voicer__paint0_linear",
    x1: 60,
    y1: 0,
    x2: 60,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#75BB03"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: 1,
    stopColor: "#008D28"
  }))));
};

exports.SvgChannelVoicer = SvgChannelVoicer;